import axios from "axios"
import {
  FLASK_DEV,
  FLASK_FEAT1_TEST,
  FLASK_FEAT2_TEST,
  FLASK_FEAT3_TEST,
  FLASK_PROD,
  FLASK_STAG,
  NODE_DEV,
  NODE_FEAT1_TEST,
  NODE_FEAT2_TEST,
  NODE_FEAT3_TEST,
  NODE_PROD,
  NODE_STAG,
} from "core/constants/strings"

type EnvType = {
  production: string
  staging: string
  development: string
  feat1: string
  feat2: string
  feat3: string
}

const FLASK_SERVER_ENV: EnvType = {
  production: FLASK_PROD,
  staging: FLASK_STAG,
  development: FLASK_DEV,
  feat1: FLASK_FEAT1_TEST,
  feat2: FLASK_FEAT2_TEST,
  feat3: FLASK_FEAT3_TEST,
}
const NODE_SERVER_ENV: EnvType = {
  production: NODE_PROD,
  staging: NODE_STAG,
  development: NODE_DEV,
  feat1: NODE_FEAT1_TEST,
  feat2: NODE_FEAT2_TEST,
  feat3: NODE_FEAT3_TEST,
}

const env = (process.env.REACT_APP_ENV || "development") as keyof EnvType
export const flask_api = axios.create({ baseURL: FLASK_SERVER_ENV[env] })
export const node_api = axios.create({ baseURL: NODE_SERVER_ENV[env] })

flask_api.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error)
)
node_api.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error)
)

const getAPI = (route: string) => {
  return flask_api.get(route)
}
const deleteAPI = (route: string, data: any) => {
  return flask_api.delete(route, { data: data })
}
const putAPI = (route: string, data: any) => {
  return flask_api.put(route, data)
}
const postAPI = (route: string, data: any, headers?: any) => {
  return flask_api.post(route, JSON.stringify(data), {
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      ...headers,
    },
  })
}
const postAPIForFiles = (route: string, data: any) => {
  return flask_api.post(route, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}

// Node server class
class Server {
  get(route: string, headers?: any) {
    return node_api.get(route, { headers })
  }
  put(route: string, data: any, headers?: any) {
    return node_api.put(route, data, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        ...headers,
      },
    })
  }
  delete(route: string, data: any, headers?: any) {
    return node_api.delete(route, {
      data: data,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        ...headers,
      },
    })
  }
  post(route: string, data: any, headers?: any) {
    return node_api.post(route, JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        ...headers,
      },
    })
  }
  postFile(route: string, data: any, headers?: any) {
    return node_api.post(route, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...headers,
      },
    })
  }
}

export { deleteAPI, getAPI, postAPI, postAPIForFiles, putAPI, Server }
